(() => {
  if (window.evaEditorialMeasurementLoaded) return;
  window.evaEditorialMeasurementLoaded = true;
  const configNode = document.getElementById('eva-editorial-measurement-config');
  if (!configNode || window.Shopify?.designMode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const pages = new Set(['familia','cuidados','qualidade','presente-natal','historia-familia','editorial-puzzle','historia-interativa','azulejo','joias-fe','nome-pedra','duas-iniciais','patas-nomes','nome-perolas','quiz']);
  const events = new Set(['advertorial_scroll','advertorial_chapter_view','advertorial_step_view','advertorial_read_all','advertorial_product_click','quiz_step_view','quiz_complete']);
  const results = new Set(['children','beads','initial','duo','hearts','puzzle']);
  const placements = new Set(['alternative','end','selection','quiz']);
  const storageKey = 'eva.editorial.attribution.v1';
  const ttl = 30 * 60 * 1000;
  const viewed = new WeakSet();
  let resultKey = '';
  let cartWrites = Promise.resolve();
  let written = '';
  let scheduled = '';
  const allowed = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; } catch { return false; }
  };
  const attributionAllowed = () => {
    try { return allowed() && window.Shopify?.customerPrivacy?.marketingAllowed() === true && config.orderAttribution === true; } catch { return false; }
  };
  const readSource = () => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (!saved || !pages.has(saved.page) || !Number.isFinite(saved.at) || saved.at > Date.now() || Date.now() - saved.at > ttl) return null;
      return { page: saved.page, at: saved.at, product: /^[a-z0-9][a-z0-9-]{0,100}$/.test(saved.product || '') ? saved.product : '' };
    } catch { return null; }
  };
  const cartUpdate = source => {
    let url;
    try { url = new URL(config.cartUpdateUrl, location.origin); } catch { return; }
    if (url.origin !== location.origin || !/\/cart\/update\.js$/.test(url.pathname)) return;
    const attributes = {__eva_article: source?.page || '', __eva_article_at: source ? new Date(source.at).toISOString() : '', __eva_article_product: source?.product || ''};
    const key = JSON.stringify(attributes);
    if (scheduled === key || (!scheduled && written === key)) return;
    scheduled = key;
    cartWrites = cartWrites.catch(() => {}).then(async () => {
      // Re-check consent immediately before each request; deletion still runs on withdrawal.
      if (source && !attributionAllowed()) {if (scheduled === key) scheduled = ''; return;}
      const response = await fetch(url.pathname, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes}),keepalive:true});
      if (response.ok) written = key;
      if (scheduled === key) scheduled = '';
    }).catch(() => {if (scheduled === key) scheduled = '';});
  };
  const clearSource = () => {
    let hadSource = false;
    try { hadSource = sessionStorage.getItem(storageKey) !== null; sessionStorage.removeItem(storageKey); } catch {}
    if (hadSource) cartUpdate(null);
  };
  const saveSource = (page, product) => {
    if (!attributionAllowed()) return;
    const source = {page,product,at:Date.now()};
    try { sessionStorage.setItem(storageKey, JSON.stringify(source)); } catch {}
    cartUpdate(source);
  };
  const publish = (name, payload) => {
    if (!allowed()) return false;
    let sent = false;
    if (typeof window.Shopify?.analytics?.publish === 'function') {
      try { Promise.resolve(window.Shopify.analytics.publish(`eva:${name}`, payload)).catch(() => {}); sent = true; } catch {}
    }
    if (config.dataLayer === true && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({event:`eva_${name}`,...payload}); sent = true;
    }
    return sent;
  };
  const pageViews = () => {
    if (!allowed()) return;
    document.querySelectorAll('[data-eva-editorial]').forEach(root => {
      if (!viewed.has(root) && pages.has(root.dataset.page) && publish('advertorial_view', {page:root.dataset.page})) viewed.add(root);
    });
  };
  document.addEventListener('eva:editorial', event => {
    const root = event.target.closest?.('[data-eva-editorial]');
    const detail = event.detail;
    if (!root || !allowed() || !detail || !events.has(detail.event) || !pages.has(root.dataset.page)) return;
    const payload = {page:root.dataset.page};
    if ([25,50,75,90].includes(detail.depth)) payload.depth = detail.depth;
    if (Number.isInteger(detail.step) && detail.step >= 1 && detail.step <= 30) payload.step = detail.step;
    if (typeof detail.product === 'string' && /^[a-z0-9][a-z0-9-]{0,100}$/.test(detail.product)) payload.product = detail.product;
    if (placements.has(detail.placement)) payload.placement = detail.placement;
    if (results.has(detail.result)) {payload.result = detail.result; resultKey = detail.result;}
    if (root.hasAttribute('data-eva-quiz') && resultKey && detail.event === 'advertorial_product_click') payload.result = resultKey;
    publish(detail.event, payload);
    if (detail.event === 'advertorial_product_click' && payload.product) saveSource(payload.page, payload.product);
  });
  const privacyReady = () => {
    if (!attributionAllowed()) clearSource();
    else {
      const source = readSource();
      if (source) cartUpdate(source); else clearSource();
    }
    pageViews();
  };
  document.addEventListener('visitorConsentCollected', privacyReady);
  document.addEventListener('shopify:section:load', pageViews);
  window.addEventListener('load', pageViews, {once:true});
  let attempts = 0;
  const loadPrivacy = () => {
    if (window.Shopify?.customerPrivacy) {privacyReady(); return;}
    if (typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {if (!error) privacyReady();});
      return;
    }
    if (++attempts < 10) setTimeout(loadPrivacy, 500);
  };
  loadPrivacy();
  // Pixel API can initialize after Customer Privacy. Retry page views without replaying interactions.
  let viewAttempts = 0;
  const retryViews = () => {pageViews(); if (++viewAttempts < 10) setTimeout(retryViews, 500);};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', retryViews, {once:true}); else retryViews();
})();
